import { Device } from "../../../types/Device";
import { DirectionalCount } from "../../../types/Count";
import { BidirectionalDeviceCard } from "./bidirectional-device-card";
import { UnidirectionalDeviceCard } from "./unidirectional-device-card";
import { ViewOnlyDeviceCard } from "./view-only-device-card";
import React from "react";

export interface DeviceCardFactoryProps {
    device: Device;
    count: DirectionalCount;
    videoId?: string;
}

function createDeviceCard(props: DeviceCardFactoryProps) {
    const config = props.device.configs?.[0];

    if (!config || config.mode === "VIDEO_ONLY") {
        return <ViewOnlyDeviceCard {...props} />;
    }

    switch (config.directionality) {
        case "UNIDIRECTIONAL":
            return <UnidirectionalDeviceCard {...props} />;
        case "BIDIRECTIONAL":
            return <BidirectionalDeviceCard {...props} />;
        default:
            console.warn(
                `Unknown device type for ${props.device.id}, defaulting to video-only`,
            );
            return <ViewOnlyDeviceCard {...props} />;
    }
}

export const DeviceCard: React.FC<DeviceCardFactoryProps> = (props) => {
    return createDeviceCard(props);
};
